import { WebPlugin } from '@capacitor/core';
export class CapacitorForegroundServiceWeb extends WebPlugin {
    async startService(options) {
        return options;
    }
    async stopService() {
        throw new Error('Method not implemented.');
    }
    async echo(options) {
        console.log('ECHO', options);
        return options;
    }
}
//# sourceMappingURL=web.js.map